module.exports = __webpack_public_path__ + "static/media/ovalnaya.6b13d431.png";